"use client";

import AppHero from "src/components/Common/AppHero";
import TechStats from "src/components/Common/TechStats";
import FAQSection from "src/components/Common/FAQSection";
import WhyChooseUs from "src/components/Common/WhyChooseUs";
import TechsSection from "src/components/Common/TechsSection";
import NavigationSection from "src/components/Common/NavigationSection";
import ProcessStepsSection from "src/components/Common/ProcessStepsSection";
import CommonContactSection from "src/components/Common/CommonContactSection";
import PagesServicesSection from "src/components/Common/PagesServicesSection";
import { flutterStatsData, flutterTechnologiesData } from "src/utils/mock/webAppData";
import { ecommerceCmsServices, ecommerceCmsFaqs, ecommerceHeroData, EcomSolutionsAndProcessData, ecommerceCmsAboutData, EcomPortfolioData } from "src/utils/mock/ecommerceCmsData";

export default function EcommerceCmsComponent({ caseStudies }) {
  const liveProjects = caseStudies?.projects?.liveProjects || [];

  const ecomProjects = liveProjects.filter((project) => {
    const hasEcomTech = project.technologies?.some((tech) => tech.name.toLowerCase() === "ecommerce" || tech.name.toLowerCase() === "e-commerce");
    const isActive = project.projectStatus?.toLowerCase() === "active";
    return hasEcomTech && isActive;
  });

  const filteredData = caseStudies
    ? {
        ...EcomPortfolioData,
        projects: {
          liveProjects: ecomProjects,
        },
      }
    : EcomPortfolioData;
  const techIcons = filteredData?.projects?.liveProjects[0]?.technologies;
  return (
    <div>
      <AppHero heroData={ecommerceHeroData} />
      <TechStats stats={flutterStatsData} />
      <NavigationSection data={ecommerceCmsServices} />
      <WhyChooseUs data={EcomSolutionsAndProcessData} />

      <section className="w-full bg-background-primary text-white px-6! md:px-12! relative overflow-hidden font-sans">
        <div className="absolute top-1/4 right-0 w-[500px] h-[500px] bg-purple-900/10 blur-[150px] -z-10 rounded-full" />
        <div className="absolute bottom-1/4 left-0 w-[500px] h-[500px] bg-blue-950/20 blur-[150px] -z-10 rounded-full" />

        <div className="max-w-8xl mx-auto!">
          <PagesServicesSection data={filteredData} />
          <ProcessStepsSection data={flutterTechnologiesData} techIcons={techIcons} />
          <TechsSection mainTitle="About E-commerce" sections={ecommerceCmsAboutData} />
        </div>
      </section>
      <FAQSection faqs={ecommerceCmsFaqs} />
      <CommonContactSection />
    </div>
  );
}
